export const onlyDigitsWithSpacesRegexp: RegExp = new RegExp(/^[0-9 ]+$/);
